import { Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { useFormContext } from "react-hook-form"
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import DialogAdicionar, { ValoresRetencao } from "./DialogAdicionar";
import tratativaDeDatas from "../../../../../helpers/tratativaDeDatas";

export default function DisplayRetencao({
    spec_name
}: DisplayRetencaoProps) {

    const { watch } = useFormContext()
    const itensRetencao: ValoresRetencao[] = watch(`${spec_name}.retencoes`) || []
    const listaItens = itensRetencao.filter(item => item.checked)

    const [openDialogAdicionar, setOpenDialogAdicionar] = useState<boolean>(false)

    const paddingStyle = { paddingLeft: 0, paddingRight: 0 }

    return (
        <>
            {
                listaItens?.length === 0 &&
                <Stack
                    direction={"column"}
                    spacing={1}
                    justifyContent={"center"}
                    alignItems={"center"}
                    minHeight={150}
                    border={1}
                    borderColor={"primary.main"}
                    borderRadius={2}
                >
                    <Typography color={"primary.main"}>
                        Nenhuma retenção cadastrada
                    </Typography>

                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={() => setOpenDialogAdicionar(true)}
                    >
                        Adicionar retenção
                    </Button>
                </Stack>
            }

            {
                listaItens?.length > 0 &&
                <TableContainer >
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={paddingStyle}><b>Descrição</b></TableCell>
                                <TableCell sx={paddingStyle}><b>Vencimento</b></TableCell>
                                <TableCell align="right" sx={paddingStyle}><b>Valor</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                listaItens.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell sx={paddingStyle}>
                                            {`${item.retencao?.id} - ${item.retencao?.descricao}`}
                                        </TableCell>

                                        <TableCell sx={paddingStyle}>
                                            {tratativaDeDatas(item.vencimento)}
                                        </TableCell>

                                        <TableCell align="right" sx={paddingStyle}>
                                            {item.valor}
                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>

                    <Stack direction="row" justifyContent="flex-end" mt={2}>
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<EditIcon />}
                            onClick={() => setOpenDialogAdicionar(true)}
                        >
                            Editar
                        </Button>
                    </Stack>
                </TableContainer>
            }

            <DialogAdicionar
                open={openDialogAdicionar}
                handleClose={() => setOpenDialogAdicionar(false)}
                spec_name={spec_name}
            />
        </>
    )
}

interface DisplayRetencaoProps {
    spec_name: string
}